import { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../lib/auth';

export default function AnnouncementBar({ variant = 'public' }) {
  const navigate = useNavigate();
  const { user } = useAuth();

  useEffect(() => {
    document.body.classList.add('has-bar');
    return () => document.body.classList.remove('has-bar');
  }, []);

  return (
    <div className="announcement-bar">
      <span className="announcement-text">First 500 Members Get 50% Off</span>
      <span className="announcement-sep">·</span>
      <span className="announcement-sub">Few Seats Left</span>
      {variant === 'app' ? (
        <button className="announcement-cta" onClick={() => navigate(user ? '/upgrade' : '/signup')}>Upgrade →</button>
      ) : (
        <Link to="/signup" className="announcement-cta">Try For Free Now →</Link>
      )}
    </div>
  );
}
